import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Products API
export const getProducts = async (params = {}) => {
  const { category, search, sort } = params;
  const queryParams = new URLSearchParams();
  
  if (category) queryParams.append('category', category);
  if (search) queryParams.append('search', search);
  if (sort) queryParams.append('sort', sort);
  
  const response = await axios.get(`${API}/products?${queryParams.toString()}`);
  return response.data;
};

export const getProduct = async (idOrSlug) => {
  const response = await axios.get(`${API}/products/${idOrSlug}`);
  return response.data;
};

export const getFeaturedProducts = async () => {
  const response = await axios.get(`${API}/featured-products`);
  return response.data;
};

// Categories API
export const getCategories = async () => {
  const response = await axios.get(`${API}/categories`);
  return response.data;
};

// Contact API
export const submitContactMessage = async (data) => {
  const response = await axios.post(`${API}/contact`, data);
  return response.data;
};

// Dealer inquiry API
export const submitDealerInquiry = async (data) => {
  const response = await axios.post(`${API}/dealer-inquiry`, data);
  return response.data;
};

// Newsletter API
export const subscribeNewsletter = async (email) => {
  const response = await axios.post(`${API}/newsletter`, { email });
  return response.data;
};

// Stats API
export const getStats = async () => {
  const response = await axios.get(`${API}/stats`, { headers: authHeader() });
  return response.data;
};

// ===== ADMIN / AUTH API =====
const TOKEN_KEY = 'admin_token';

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminLogin = async (email, password) => {
  const response = await axios.post(`${API}/auth/login`, { email, password });
  return response.data;
};

export const getAuthMe = async () => {
  const response = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return response.data;
};

export const getAdminStats = async () => {
  const response = await axios.get(`${API}/stats`, { headers: authHeader() });
  return response.data;
};

export const getOrders = async (status) => {
  const params = status ? `?status=${status}` : '';
  const response = await axios.get(`${API}/orders${params}`, { headers: authHeader() });
  return response.data;
};

export const getDealerInquiries = async () => {
  const response = await axios.get(`${API}/dealer-inquiry`, { headers: authHeader() });
  return response.data;
};

export const getContactMessages = async () => {
  const response = await axios.get(`${API}/contact`, { headers: authHeader() });
  return response.data;
};

export const getNewsletterSubscribers = async () => {
  const response = await axios.get(`${API}/newsletter`, { headers: authHeader() });
  return response.data;
};

export const downloadCsv = async (path, filename) => {
  const response = await axios.get(`${API}${path}`, {
    headers: authHeader(),
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// ===== ADMIN SALES API =====
export const getAdminSales = async () => {
  const response = await axios.get(`${API}/admin/sales`, { headers: authHeader() });
  return response.data;
};

export const createAdminSale = async (data) => {
  const response = await axios.post(`${API}/admin/sales`, data, { headers: authHeader() });
  return response.data;
};

export const updateAdminSale = async (id, data) => {
  const response = await axios.put(`${API}/admin/sales/${id}`, data, { headers: authHeader() });
  return response.data;
};

export const endAdminSale = async (id) => {
  const response = await axios.post(`${API}/admin/sales/${id}/end`, {}, { headers: authHeader() });
  return response.data;
};

export const deleteAdminSale = async (id) => {
  const response = await axios.delete(`${API}/admin/sales/${id}`, { headers: authHeader() });
  return response.data;
};

// ===== ADMIN SHIPPING API =====
export const shipOrder = async (orderId, data) => {
  const response = await axios.post(`${API}/orders/${orderId}/ship`, data, { headers: authHeader() });
  return response.data;
};
